import * as Types from '../../constants/actionTypes';
const initState = {
  inquiryCategories: [],
}
export default (state = initState, action) => {
  switch (action.type) {
    case Types.GET_LIST_INQUIRY_CATEGORY_SUCCESS: {
      return {
        ...state,
        inquiryCategories: action.payload
      }
    }
    default:
      return state;
  }
};